import React, { useState, useEffect, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import DivLayout from 'components/sales/divLayout/divLayout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import moment from 'moment';

const ViewMomDetails = ({ getMomBymeetingId, momBymeetingId, match }) => {
  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getMomBymeetingId(match?.params?.id);
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (momBymeetingId) {
      setDetails(momBymeetingId);
    }
  }, [momBymeetingId]);

  return (
    <Layout
      title={localization.momDetails}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meetings/${details?.site_id}`}
    >
      {details !== null && Object.keys(details).length !== 0 && (
        <div className="panel-card">
          <div className="panel-heading">{localization.momDetails}</div>
          <div className="panel-body">
            <div className="details-listing">
              <DivLayout
                heading={localization.meetingDate}
                data={
                  details?.meeting_date
                    ? moment(details.meeting_date).format('DD-MM-YYYY')
                    : ''
                }
              />
              <DivLayout
                heading={localization.meetingTime}
                data={
                  details?.meeting_time ? details.meeting_time : localization.na
                }
              />
              <DivLayout
                heading={localization.meetingOrganisor}
                data={
                  details?.organiser_name
                    ? details.organiser_name
                    : localization.na
                }
              />
              <DivLayout
                heading={localization.meetingLoc}
                data={
                  details?.meeting_location
                    ? details.meeting_location
                    : localization.na
                }
              />
              <DivLayout
                heading={localization.attendees}
                data={details?.attendees ? details.attendees : localization.na}
              />
              <DivLayout
                heading={localization.meetingDesc}
                data={
                  details?.description ? details.description : localization.na
                }
              />
              <DivLayout
                heading={localization.status}
                data={details?.status ? details.status : localization.na}
                status
              />
              {details?.agenda && (
                <DivLayout
                  heading={localization.meetingAgenda}
                  data={details?.agenda ? details.agenda : localization.na}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default ViewMomDetails;
